/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { Notification } from 'model/Notification'
import { ShowException } from 'store/Application/appActions'
import { UpdateManager } from 'utils/updateManager'
import { fetchProject } from './fetchProject'
import {
  subscribeToUpdates,
  unsubscribeFromUpdates,
} from './liveUpdatesActions'

const updateQueue = new UpdateManager({
  paceInSeconds: 5,
  queueName: 'UPDATES',
})

// let handlerCounter = 0

export const subscribeToProjectNotifications = createAsyncThunk<
  void,
  string,
  { state: any }
>('project/subscribeToUpdates', async (groupName, thunkAPI) => {
  thunkAPI.dispatch(
    subscribeToUpdates({
      groupName,
      clientMethodName: 'onProjectProgress',
      clientMethod: (notification: Notification) => {
        if (notification.shallUpdateUI) {
          updateQueue.addTask(() => {
            return thunkAPI.dispatch(
              fetchProject({
                projectId: thunkAPI.getState().project?.activeProject?.id,
              })
            )
          })
        }
      },
    })
  )
})

export const unsubscribeFromActiveProjectUpdates = createAsyncThunk<
  void,
  null,
  { state: any }
>('project/unsubscribeFromUpdates', async (_, thunkAPI) => {
  try {
    updateQueue.clear()

    if (!thunkAPI.getState().project.activeProject) {
      return
    }

    const { id, isBuyingPartyView } = thunkAPI.getState().project.activeProject

    if (!id) {
      return
    }

    const groupName = `${id}_${isBuyingPartyView ? 'buyers' : 'sellers'}`

    await thunkAPI.dispatch(
      unsubscribeFromUpdates({
        groupName,
        clientMethodName: 'onProjectProgress',
      })
    )
  } catch (ex) {
    ShowException('project', ex)
    throw ex
  }
})
